import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

import API from "@dndUtilities/system_api";

import StringBox from "@components/input/strings/StringBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";

interface Props {
  character: Character;
}

const api = API.getInstance();

export default function CharacterNotesInput({ 
  character,
}: Props) {
  const [ping, setPing] = useState(false);
  const [view, setView] = useState("ALL");
  
  const enabled = api.user && (character.owner_id === api.user._id || (character.campaign && character.campaign.owner_id === api.user._id));
  return (
    <Grid container spacing={0} direction="row" className="curved_border bg_black_transp" 
      style={{
        fontSize: "11px"
      }}>
      <Grid size={12}>
        <div className="centered">
          <CenteredMenu
            options={["ALL", "Orgs", "Allies", "Enemies", "Backstory", "Other"]}
            selected={view}
            onSelect={setView}
          />
        </div>
      </Grid>
      { (view === "ALL" || view === "Orgs") && 
        <Grid size={12}>
          <StringBox 
            name="Organizations" 
            disabled={ !enabled }
            value={character.notes.organizations}
            multiline
            onBlur={(changed: string) => {
              character.notes.organizations = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Allies") && 
        <Grid size={12}>
          <StringBox 
            name="Allies" 
            disabled={ !enabled }
            value={character.notes.allies}
            multiline
            onBlur={(changed: string) => {
              character.notes.allies = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Enemies") && 
        <Grid size={12}>
          <StringBox 
            name="Enemies" 
            disabled={ !enabled }
            value={character.notes.enemies}
            multiline
            onBlur={(changed: string) => {
              character.notes.enemies = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Backstory") && 
        <Grid size={12}>
          <StringBox 
            name="Backstory" 
            disabled={ !enabled }
            value={character.notes.backstory}
            multiline
            onBlur={(changed: string) => {
              character.notes.backstory = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Other") && 
        <Grid size={12}>
          <StringBox 
            name="Other" 
            disabled={ !enabled }
            value={character.notes.other_notes}
            multiline
            onBlur={(changed: string) => {
              character.notes.other_notes = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
    </Grid>
  );
}

